'use strict';

import { Checkbox, Col, DatePicker, Form, Input, InputNumber, Row, Select, TreeSelect } from 'antd';
import moment from 'moment';
import React from 'react';
import { getSCEditor } from './Dnd_SgiFormEditorCommon';
import { EditorTypes } from './Dnd_SgiFormEditorCommonConstants';
import { fitModalInfo } from './sgiDndDevComFun';
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory'
import { SgiMainComp } from 'rt-sd-comp/sgiComp/SgiMainComp';
import smProjDndConfig from 'rt-sd-common/sgiConfig/smProjDndConfig'

const FormItem = Form.Item;
const Option = Select.Option;
const SHOW_PARENT = TreeSelect.SHOW_PARENT;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};

const formCtlTypesDesid = [
    "EP_EO_UI_3101",
    "EP_EO_UI_3102",
    "EP_EO_UI_3106",
    "EP_EO_UI_3105",
    "EP_EO_UI_3104",
    "EP_EO_UI_3122",
    "EP_EO_UI_3123",
    "EP_EO_UI_3107",
    "EP_EO_NUI_0001",
    "EP_EO_UI_3110",
    "EP_EO_UI_3108",
    "EP_EO_UI_3109",
    "EP_EO_UI_3011",
    "EP_EO_UI_3118",
    "EP_EO_UI_3114",
    "EP_EO_UI_3012"
];

const ctlTypeOption =
    [<Option value="EP_EO_UI_3101">文本框</Option>,
    <Option value="EP_EO_UI_3102">文本域</Option>,
    <Option value="EP_EO_UI_3106">日期控件</Option>,
    <Option value="EP_EO_UI_3105">时间控件</Option>,
    <Option value="EP_EO_UI_3104">数字控件</Option>,
    <Option value="EP_EO_UI_3122">级联控件</Option>,
    <Option value="EP_EO_UI_3123">CodeMirror</Option>,
    <Option value="EP_EO_UI_3107">下拉框</Option>,
    <Option value="EP_EO_NUI_0001">下拉树</Option>,
    <Option value="EP_EO_UI_3110">复选框</Option>,
    <Option value="EP_EO_UI_3108">复选框组</Option>,
    <Option value="EP_EO_UI_3109">单选框组</Option>,
    <Option value="EP_EO_UI_3011">弹出窗</Option>,
    <Option value="EP_EO_UI_3118">文件控件</Option>,
    <Option value="EP_EO_UI_3018">tag</Option>,
    <Option value="EP_EO_UI_3012">富文本</Option>];

const getModuleDesc2valuesHandler = (dndDispatchObject, dnd_id) => ({
    set: function (target, key, value, receiver) {
        if (key === "_currentDndCtl") {
            return Reflect.set(this, key, value);
        } else if (key === "_prefix") {
            return Reflect.set(this, key, value);
        } else if (this._currentDndCtl) {
            // if (key === "desId") this._currentDndCtl.changeComp();
            // else this._currentDndCtl.refresh(key, value);
            try {
                this._currentDndCtl.refresh(key, value);
            } catch (error) {
                // console.log("第二次 回显的时候 ref丢失问题，暂时未解决，先注掉，别影响后续操作");
            }

        }
        if (Object.prototype.toString.call(value) === "[object Object]") {
            let proxyVal = new Proxy(value, getModuleDesc2valuesHandler(dndDispatchObject, dnd_id));
            proxyVal._prefix = (this._prefix || "") + key + ".";
            proxyVal._currentDndCtl = this._currentDndCtl;
            return Reflect.set(target, key, proxyVal);
        } else {
            dndDispatchObject.updateUIJson(dnd_id, (this._prefix || "") + key, value);
            return Reflect.set(target, key, value);
        }
    }
});

var textOnChange = (currentModule, attname, e, e2) => {
    let value = e.target.value;
    currentModule.refresh(attname, value);
}

var datePickerOnChange = (currentModule, attname, e, e2) => {
    let value = e2;
    currentModule.refresh(attname, value);
}

var numberOnChange = (currentModule, attname, e) => {
    let value = e;
    currentModule.refresh(attname, value);
}
var updateCode = (currentModule, attname, newCode) => {
    let value = newCode;
    currentModule.refresh(attname, value);
}

var selectOnChange = (currentModule, attname, value) => {//change传入对象为value
    currentModule.refresh(attname, value);

    //获取拖拽全局对象
    let dndDispatchObject = currentModule.props.dndDispatchObject ||
        currentModule.props.currentCtl.props.dndDispatchObject;

    //如果属性是desId
    //重置页面 重置编辑页面
    if (attname == "desId") {
        //更新编辑页面
        fitModalInfo(currentModule.props.currentCtl);
        // sgiDndDevComFun
        //更新展示页面
        let mainUI = dndDispatchObject.getMainUI();
        mainUI.refresh();
    }

}

var checkOnChange = (currentModule, attname, e) => {
    let value = e.target.checked;
    currentModule.refresh(attname, value);
}

var onSearch = (currentModule, attname, e) => {
    let value = e.target.checked;
    currentModule.refresh(attname, value);
}

var teOnBlur = (currentModule, attname, attname2, e, e2) => {
    let ap = tool.Global.currentAP;
    let tt = "RP";
    let ss = "TR";
    let val = e.target.value;
    if (!val) return;

    //调用校验保存方法
    let result = PrmFactory.existResource(ap, tt, ss, val);
    if (result) {
        //如果存在则把表中数据放入该参数中
        let sc = result.sc;
        currentModule.refresh(attname, val);
        currentModule.refresh(attname2, sc);
        return;
    }
    //不存在该资源
    let id = tool.uuidDate();
    let newObj = { 'ap': ap, 'tt': tt, 'ss': ss, 'te': val, 'sc': id };
    result = PrmFactory.saveResources(newObj);
    if (result == 0) {
        currentModule.refresh(attname, val);
        currentModule.refresh(attname2, id);
        console.log("文本资源保存成功");
        // tool.popMsgDialog("提示", "文本资源保存成功！");
    }
}

var ctrlHidFlg = (currentModule, attname, flg) => {
    currentModule.state["editorPropHiddenFlg_" + attname] = flg;
}
var getHidFlg = (currentModule, attname) => {
    return currentModule.state["editorPropHiddenFlg_" + attname];
}
var vldCCtrlHidFlg = (currentModule, value) => {
    // 如果是数字类型的值，可以进行最大值最小值限制
    if (value && (value === "int" || value === "double" || value === "money" || value === "number")) {
        ctrlHidFlg(currentModule, "minV", undefined);
        ctrlHidFlg(currentModule, "maxV", undefined);
    } else {
        ctrlHidFlg(currentModule, "minV", true);
        ctrlHidFlg(currentModule, "maxV", true);
    }
}

var vldCOnChangeAndCtrlHidFlg = (currentModule, attname, e, e2) => {
    selectOnChange(currentModule, attname, e, e2);
    vldCCtrlHidFlg(currentModule, e);
}

var getColUnit = (code, currentModule) => {
    switch (code) {
        // 通用基本属性
        case "te": return getColFun(currentModule, "Input", "显示名称", code, 8, null, { onBlur: teOnBlur.bind(this, currentModule, "te", "teid"), placeholder: "组件的显示名称" });
        case "alwBlk": return getColFun(currentModule, "Checkbox", "允许为空", code, 3, { labelCol: { span: 20 } });
        case "isDis": return getColFun(currentModule, "Checkbox", "禁用", code, 2, { labelCol: { span: 18 } });
        case "isRead": return getColFun(currentModule, "Checkbox", "只读", code, 2, { labelCol: { span: 18 } });
        case "isHdn": return getColFun(currentModule, "Checkbox", "隐藏", code, 2, { labelCol: { span: 18 } });
        case "isLbl": return getColFun(currentModule, "Checkbox", "隐藏标签", code, 3, { labelCol: { span: 18 } });
        case "isLabel": return getColFun(currentModule, "Checkbox", "仅显示", code, 2, { labelCol: { span: 16 } });
        case "nowrap": return getColFun(currentModule, "Checkbox", "不换行", code, 2, { labelCol: { span: 16 } });
        case "isPwd": return getColFun(currentModule, "Checkbox", "密码控件", code, 3, { labelCol: { span: 14 } });
        case "c": return getColFun(currentModule, "Input", "属性名", code, 8, null, { placeholder: 'form绑定实例名中对应对象的属性key' });
        case "c_mult": return getColFun(currentModule, "Input", "属性名", "c", 8, null, { placeholder: '如对应多个属性key请使用","分割' });
        case "cId": return getColFun(currentModule, "Input", "控件id", code, 8, null, { placeholder: '组件的唯一标识' });
        case "lblAlg": return getColFun(currentModule, "Select", "标签位置", code, 8, null, null, [<Option value="left">靠左</Option>, <Option value="center">居中</Option>, <Option value="right">靠右</Option>]);
        case "lblW": return getColFun(currentModule, "InputNumber", "标签宽度", code, 6, null, { defaultValue: 0 });
        case "ctlW": return getColFun(currentModule, "InputNumber", "组件宽度", code, 5, null, { defaultValue: 0 });
        case "ctlH": return getColFun(currentModule, "InputNumber", "组件高度", code, 5, null, { defaultValue: 0 });
        case "desId": return getColFun(currentModule, "Select", "组件类型", code, 8, null, { defaultValue: 'EP_EO_UI_3101' }, ctlTypeOption);

        // 其他属性
        case "vldC":
            let value = currentModule.state.values[code];
            vldCCtrlHidFlg(currentModule, value);//初始控制最大值、最小值显示
            return getColFun(currentModule, "Select", "校验类型", code, 8, null, { onChange: vldCOnChangeAndCtrlHidFlg.bind(this, currentModule, code), placeholder: '--请选择--' }, [
                <Option value="">无</Option>,
                <Option value="int">整数</Option>,
                <Option value="double">double</Option>,
                <Option value="money">金额</Option>,
                <Option value="email">email</Option>,
                <Option value="idcard18">身份证</Option>,
                <Option value="phone">电话号</Option>,
                <Option value="mobile">手机号</Option>,
                <Option value="zip">邮政</Option>,
                <Option value="url">url</Option>,
                <Option value="qq">QQ号</Option>,
                <Option value="number">数字</Option>,
                <Option value="汉字">汉字</Option>,
                <Option value="字母">字母</Option>]);
        case "defVal10": return getColFun(currentModule, "Input", "初始值", code, 8, null, { placeholder: "初始值" });
        case "escape": return getColFun(currentModule, "Input", "转义", code, 8, null, { placeholder: "默认true/false，可输入1/0等" });
        case "bdText": return getColFun(currentModule, "Input", "文本后信息", code, 8, null, { placeholder: "文本后显示内容，常用作单位" });
        case "minL": return getColFun(currentModule, "InputNumber", "最小长度", code, 8, null, { defaultValue: 0 });
        case "maxL": return getColFun(currentModule, "InputNumber", "最大长度", code, 8, null, { defaultValue: 0 });
        case "inpPopTe": return getColFun(currentModule, "Input", "输入提示文本", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } });
        case "emptyText": return getColFun(currentModule, "Input", "下拉项为空提示", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } });
        case "minV": return getColFun(currentModule, "InputNumber", "最小值", code, 8, null, { defaultValue: 0 });
        case "maxV": return getColFun(currentModule, "InputNumber", "最大值", code, 8, null, { defaultValue: 0 });
        case "step": return getColFun(currentModule, "InputNumber", "微调间距", code, 8);
        case "intDgt": return getColFun(currentModule, "InputNumber", "整数位", code, 8);
        case "dcmDgt": return getColFun(currentModule, "InputNumber", "小数位", code, 8);
        case "ctlRow": return getColFun(currentModule, "InputNumber", "行数", code, 8, null, { defaultValue: 0 });
        case "isScl": return getColFun(currentModule, "Checkbox", "可滚动", code, 8);
        case "dateFmt": return getColFun(currentModule, "Input", "日期格式", code, 8, null, { placeholder: currentModule.state.fmtPlaceholder });
        case "optBDt": return getColFun(currentModule, "DatePicker", "可选的起始日期", code, 8, null, { format: currentModule.state.values.dateFmt || currentModule.state.fmtPlaceholder });
        case "optEDt": return getColFun(currentModule, "DatePicker", "可选的结束日期", code, 8, null, { format: currentModule.state.values.dateFmt || currentModule.state.fmtPlaceholder });
        case "dateTimeFlag": return getColFun(currentModule, "Checkbox", "是否显示时间", code, 8);
        case "ctlMode": return getColFun(currentModule, "Select", "组件模式", code, 8, null, { defaultValue: "date" }, [
            <Option value="date">日期模式</Option>,
            <Option value="dateTime">日期时间模式</Option>,
            <Option value="month">月模式</Option>,
            <Option value="week">周模式</Option>,
            <Option value="year">年模式</Option>,
            <Option value="dateRange">日期范围模式</Option>,
            <Option value="dateTimeRange">日期时间范围模式</Option>]);
        case "hourStep": return getColFun(currentModule, "InputNumber", "小时选项间隔", code, 8);
        case "minuteStep": return getColFun(currentModule, "InputNumber", "分钟选项间隔", code, 8);
        case "secondStep": return getColFun(currentModule, "InputNumber", "秒选项间隔", code, 8);
        case "timeFmt": return getColFun(currentModule, "Input", "时间格式", code, 8, null, { placeholder: "HH:mm:ss" });
        case "btnN": return getColFun(currentModule, "Input", "按钮名称", code, 8);
        case "cluW": return getColFun(currentModule, "InputNumber", "按钮宽度", code, 8);
        case "iconPh": return getColFun(currentModule, "Input", "按钮图标", code, 8);
        case "disType": return getColFun(currentModule, "Select", "上传列表样式", code, 8, null, { defaultValue: "text" }, [
            <Option value="text">基础样式</Option>,
            <Option value="picture">图片列表样式</Option>,
            <Option value="picture-card">照片墙样式</Option>]);
        // case "accept": return getColFun(currentModule, "Input", "接受文件类型", code, 8);
        case "accept": return getColFun(currentModule, "Select", "接受文件类型", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } }, { placeholder: "所有文件", mode: "tags" }, [
            <Option value="image/*">图片文件</Option>,
            <Option value="audio/*">音频文件</Option>,
            <Option value="video/*">视频文件</Option>,
            <Option value=".jpg">jpg文件</Option>,
            <Option value=".png">png文件</Option>,
            <Option value=".doc">doc文件</Option>,
            <Option value="." disabled={true}>其他类型请直接输入后缀，如".docx"等，然后按回车键即可</Option>]);
        case "action": return getColFun(currentModule, "Input", "上传地址", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } });
        case "mulSel": return getColFun(currentModule, "Checkbox", "多选", code, 2, { labelCol: { span: 18 } });
        case "allowClear": return getColFun(currentModule, "Checkbox", "支持清除", code, 3, { labelCol: { span: 18 } });
        case "isDrag": return getColFun(currentModule, "Checkbox", "拖拽样式", code, 3, { labelCol: { span: 18 } });
        case "hdUpld": return getColFun(currentModule, "Checkbox", "数量上限隐藏上传", code, 4, { labelCol: { span: 18 } });
        case "nLimit": return getColFun(currentModule, "InputNumber", "上传数量限制", code, 8);
        case "isBttn": return getColFun(currentModule, "Checkbox", "普通按钮", code, 3, { labelCol: { span: 18 } });
        case "isHdnLst": return getColFun(currentModule, "Checkbox", "隐藏文件列表", code, 4, { labelCol: { span: 18 } });
        case "scId": return getSCEditor(currentModule);
        case "shows": let treeData = currentModule.state.values.showsTreeData = (StandardCode.getSC(currentModule.state.values.scId) || []).map(sc => ({ title: sc.te, value: sc.c }));
            return getColFun(currentModule, "TreeSelect", "显示项", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } }, {
                placeholder: "默认全部",
                treeData: treeData,
                treeCheckable: true,
                showCheckedStrategy: SHOW_PARENT,
            });
        case "autoSel": return getColFun(currentModule, "Checkbox", "自动选择", code, 3, { labelCol: { span: 18 } });
        case "search": return getColFun(currentModule, "Checkbox", "搜索框", code, 3, { labelCol: { span: 18 } });
        case "checked": return getColFun(currentModule, "Input", "默认选中项", code, 8, null, { placeholder: "默认选中项编码" });
        case "isCustom": return getColFun(currentModule, "Checkbox", "自定义", code, 8);
        case "uid": return getColFun(currentModule, "Input", "页面GUID", code, 8, null, { placeholder: "弹出页面的GUID标识" });
        case "fileUploadUrl": return getColFun(currentModule, "Input", "文件上传地址", code, 16, { labelCol: { span: 4 }, wrapperCol: { span: 20 } }, { placeholder: "文件上传地址" });
        case "toolbarHidden": return getColFun(currentModule, "Checkbox", "隐藏工具条", code, 8);
        case "current": return getColFun(currentModule, "Input", "current？？？", code, 8);
        case "progressDot": return getColFun(currentModule, "Input", "点状步骤条", code, 8);
        case "direction": return getColFun(currentModule, "Select", "步骤条方向", code, 8, null, null, [
            <Option value="top">上</Option>,
            <Option value="bottom">下</Option>,
            <Option value="left">左</Option>,
            <Option value="right">右</Option>]);
        case "insName": return getColFun(currentModule, "Input", "绑定实例名", code, 8, null, { placeholder: "绑定实例名" });
        case "showKey": return getColFun(currentModule, "Input", "显示属性名", code, 8, null, { placeholder: "用于显示的属性编码" });
        case "saveKey": return getColFun(currentModule, "Input", "保存属性名", code, 8, null, { placeholder: "实际存储的属性编码" });
        case "numLimit": return getColFun(currentModule, "InputNumber", "下拉数", code, 5);

        case "selectType": return getColFun(currentModule, "Select", "添加符号", code, 8, null, { placeholder: "默认无" }, [
            <Option value="00">无</Option>,
            <Option value="01">金钱符号</Option>,
            <Option value="02">百分比符号</Option>]);

        case "occupiedSmall": return getColFun(currentModule, "Input", "列数-小(比例24格)", code, 8, { labelCol: { span: 12 }, wrapperCol: { span: 12 } }, { placeholder: "默认6" });
        case "occupiedBig": return getColFun(currentModule, "Input", "列数-大(比例24格)", code, 8, { labelCol: { span: 12 }, wrapperCol: { span: 12 } }, { placeholder: "默认6" });
        case "browserWidth": return getColFun(currentModule, "Input", "浏览器对比宽度", code, 8, { labelCol: { span: 8 }, wrapperCol: { span: 16 } }, { placeholder: "使用则必填，大于用大列" });
        case "occupied": return getColFun(currentModule, "Input", "单项占比", code, 8, { labelCol: { span: 8 }, wrapperCol: { span: 16 } }, { placeholder: "24格划分" });
        case "astrict": return getColFun(currentModule, "Input", "显示最大数量", code, 8, { labelCol: { span: 8 }, wrapperCol: { span: 16 } });

        default: return (<div>未找到code为：{code}的组件</div>);
    }
}


var getColUnitByDesc = (ctlDesc, currentModule) => {
    return getColFun(
        currentModule,
        ctlDesc.ctlName,
        ctlDesc.te,
        ctlDesc.code,
        ctlDesc.span,
        ctlDesc.layout,
        ctlDesc.props,
        ctlDesc.children
    );
}

var getColFun = (currentModule, itemType, label, keyCode, span, layout, props, children) => {
    //如果是隐藏状态，直接返回
    if (getHidFlg(currentModule, keyCode)) return;

    props = props || {};
    // props.style = props.style || {};
    layout = layout || formItemLayout;

    // 前处理
    // switch (itemType) {
    //     case "InputNumber":
    //         props.style.width = "100%"; //解决数字组件不充满问题
    //         break;
    //     default:
    //         break;
    // }

    return (
        <Col span={span}>
            <FormItem {...layout} label={label}>
                {getItemFun(currentModule, itemType, keyCode, props, children)}
            </FormItem>
        </Col>
    );
}
var getItemFun = (currentModule, itemType, keyCode, props, children) => {
    switch (itemType) {
        case "Input": return (<Input {...props} value={currentModule.state.values[keyCode]} onChange={textOnChange.bind(this, currentModule, keyCode)} />);
        case "InputNumber": return (<InputNumber {...props} value={currentModule.state.values[keyCode]} onChange={numberOnChange.bind(this, currentModule, keyCode)} />);
        case "Checkbox": return (<Checkbox {...props} checked={currentModule.state.values[keyCode]} onChange={checkOnChange.bind(this, currentModule, keyCode)} />);
        case "Select": return (<Select value={currentModule.state.values[keyCode]} onChange={selectOnChange.bind(this, currentModule, keyCode)} {...props}>{children}</Select>);
        case "TreeSelect": return (<TreeSelect value={currentModule.state.values[keyCode]} onChange={selectOnChange.bind(this, currentModule, keyCode)} {...props}>{children}</TreeSelect>);
        case "DatePicker": let dValue = currentModule.state.values[keyCode]; let dFormat = props.format;
            return (<DatePicker {...props} value={dValue ? moment(dValue, dFormat) : null} onChange={datePickerOnChange.bind(this, currentModule, keyCode)} />);
        default: return (<div>未找到类型为：{itemType}的组件</div>);
    }
}

var getEditor = (currentModule, type) => {
    type = type || "Common";
    let editorCodes = EditorTypes[type];
    var { dndDispatchObject, moduleDesc } = currentModule.props.currentCtl.props;
    if (window._popFormCtlEditorDesid == moduleDesc.dnd_id 
            && Object.keys(window._popFormCtlEditor.props.children.props.moduleDesc).length > 0) {
        return window._popFormCtlEditor;
    } else {
        window._popFormCtlEditorDesid = moduleDesc.dnd_id;
    }
    let currentNode = dndDispatchObject.findNodeByDndID(dndDispatchObject.getRootChildren(), moduleDesc.dnd_id);
    if (formCtlTypesDesid.indexOf(currentNode.desId) >= 0) {
        //创建开发平台开发的属性编辑页面 rtsd_UI_DSD_0004
        // guid参数
        // let guid = "rtsd_UI_DSD_0005";
        let guid = smProjDndConfig.getDSDPreviewSelectGuid();
        let ucvData = PrmFactory.getPrm(guid);
        if (!ucvData) return null;
        var objFct = new ObjFactory(guid);

        let record = new Proxy(currentNode, getModuleDesc2valuesHandler(dndDispatchObject, moduleDesc.dnd_id));
        record._currentDndCtl = currentModule;

        objFct.set("dvRecord", record);
        objFct.set("db_dv_item_info", record);
        objFct.set("dnd_flag", true);
        window._popFormCtlEditor = (
            <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                <SgiMainComp key={tool.uuid(8)} objFct={objFct} moduleDesc={ucvData}>
                </SgiMainComp>
            </div>
        );
        return window._popFormCtlEditor;
    } else {
        window._popFormCtlEditor = (
            <Form>
                {editorCodes.map((rows) => (
                    <Row>
                        {rows.map((col) => {
                            return getColUnit(col, currentModule);
                        })}
                    </Row>
                ))}
            </Form>
        );
        return window._popFormCtlEditor;
    }
}

export { formItemLayout, textOnChange, numberOnChange, updateCode, selectOnChange, checkOnChange, onSearch, teOnBlur, datePickerOnChange, getColUnit, getEditor, getColUnitByDesc, getHidFlg, ctrlHidFlg, vldCCtrlHidFlg, vldCOnChangeAndCtrlHidFlg };



// WEBPACK FOOTER //
// ./~/rt-sd-dnd/sgiDndDev/Dnd_SgiFormEditorCommonUtils.js